module.exports = __webpack_public_path__ + "img/solarroof@2x.93d70c4.jpg";